export enum PostHogEvent {
  // Resume events
  RESUME_RANDOM_TITLE = "resume_random_title",
  RESUME_CREATE_SAMPLE = "resume_create_sample",
  RESUME_LOCK = "resume_lock",
  RESUME_CHOOSE_TEMPLATE = "resume_choose_template",

  // Auth events
  USER_LOGIN = "user-login",
}
